import { render, staticRenderFns } from "./myOperationAsk.vue?vue&type=template&id=38cdb516&scoped=true"
import script from "./myOperationAsk.vue?vue&type=script&lang=js"
export * from "./myOperationAsk.vue?vue&type=script&lang=js"
import style0 from "./myOperationAsk.vue?vue&type=style&index=0&id=38cdb516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cdb516",
  null
  
)

export default component.exports